import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines } from "../../components/motion";
import { SectionLabel } from "../../components/SectionLabel";
import { ArticleCard } from "../../components/ArticleCard";
import { asList, useFetch } from "../../lib/api";

export const LatestInsights = () => {
  const { data } = useFetch("/articles");
  const items = asList(data).slice(0, 3);
  if (!items.length) return null;
  return (
    <section data-testid="home-insights" className="bg-paper py-24 sm:py-32">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div>
            <SectionLabel index="05" className="text-moss">Insights & news</SectionLabel>
            <MaskLines lines={["Research, innovation", "and extension, for the field."]} className="mt-8 font-display text-4xl font-normal leading-[1.02] tracking-[-0.02em] text-teal sm:text-5xl lg:text-6xl" />
            <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-teal-ink/80">
              Technical notes for growers, agronomists, advisors and product group representatives.
            </p>
          </div>
          <Link to="/insights" data-testid="home-insights-viewall" className="group label-caps inline-flex items-center gap-3 self-start text-teal lg:self-auto">
            <span className="link-underline pb-1">All insights</span>
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
          </Link>
        </div>
        <div className="mt-16 grid gap-x-8 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
          {items.map((a, i) => (
            <ArticleCard key={a.id} article={a} index={i} featured={i === 0} />
          ))}
        </div>
      </div>
    </section>
  );
};
